export class Firmar {
    id_proceso!: number;
    id_usuario!: number;
    matricula!: string;
    expediente!:string;
    fecha_expedicion!:String;
    id_profesion!:number;
    fecha_matriculacion!:String;
}